import { ResourceEnum } from "src/constants/constants.ts";
import { mapResourceToRow } from "src/admin/lists/b2b-gate-order/mapResourceToRow.ts";
import { mapProductResourceToProductRow } from "src/admin/lists/product/mapProductResourceToProductRow.tsx";

export const getDataGridCustomMapper = ({
  resource,
}: {
  resource: string;
}): ((resource: any) => any) | undefined => {
  if (resource === ResourceEnum.Product) {
    return mapProductResourceToProductRow;
  }

  if (resource === ResourceEnum.B2bGateOrder) {
    return mapResourceToRow;
  }
  return undefined;
};
